import {
  FlowModuleItemType,
  FlowModuleTemplateType,
} from "@packages/flow-core/module";
import { Dispatch, SetStateAction, createContext } from "react";
import { NodeChange, Node, Edge, EdgeChange } from "reactflow";

export type FlowContextType = {
  getAllNodes: () => Node<FlowModuleItemType, string | undefined>[];
  setNodes: Dispatch<
    SetStateAction<Node<FlowModuleItemType, string | undefined>[]>
  >;
  onNodesChange: (nodeChanges: NodeChange[]) => void;
  getAllEdges: () => Edge<any>[];
  setEdges: Dispatch<SetStateAction<Edge<any>[]>>;
  onEdgesChange: (nodeChanges: EdgeChange[]) => void;
  mode: "app" | "plugin" | "template";
  templates?: FlowModuleTemplateType[];
  llmModels?: { label: string; value: string }[];
  systemVariables?: { label: string; key: string }[];
  useablePlugins?: FlowModuleTemplateType[]; // 同模板
};

export const FlowContext = createContext<FlowContextType>({
  getAllNodes() {
    return [];
  },
  setNodes() {},
  onNodesChange() {},
  getAllEdges() {
    return [];
  },
  setEdges() {},
  onEdgesChange() {},
  mode: "app",
});
export const FlowProvider = FlowContext.Provider;
// export const FlowProvider = (props: {
//   initialNodes?: Node<FlowModuleItemType>[];
//   children?: ReactNode | Iterable<ReactNode> | string | number;
//   mode: 'app' | 'plugin';
// }) => {
//   const [nodes, setNodes, onNodesChange] = useNodesState(props.initialNodes ?? []);
//   const [edges, setEdges, onEdgesChange] = useEdgesState([]);

//   useMemo(() => {
//     console.log('nodes update');
//   }, [onNodesChange]);

//   const nodesRef = useRef(nodes);
//   const edgesRef = useRef(edges);
//   nodesRef.current = nodes;
//   edgesRef.current = edges;

//   const getAllNodes = useCallback(() => {
//     return nodesRef.current;
//   }, []);

//   const getAllEdges = useCallback(() => {
//     return edgesRef.current;
//   }, []);

//   return (
//     <FlowContext.Provider
//       value={{
//         setNodes,
//         onNodesChange,
//         setEdges,
//         onEdgesChange,
//         mode: props.mode,
//         getAllEdges,
//         getAllNodes,
//       }}
//     >
//       {props.children}
//     </FlowContext.Provider>
//   );
// };
